import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, retry, switchMap } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { AdvisorResponse, AdvisorSingularData } from '../../../domain/interfaces/advisor/advisor.interface';

@Injectable({
    providedIn: 'root',
})

export class AdvisorService {

    constructor(private http: HttpClient) { }
    baseUrl = `${environment.apiBaseUrl}${environment.endpoints.ApiAdvisors}`;
    private authService = inject(AuthService);


    public getAdvisorInformation(_sessionId: string, BodyAdvisor: string): Observable<AdvisorSingularData> {
        return this.authService.getAuthHeaders().pipe(
            switchMap(headers => {
                const urlWithTimestamp = `${this.baseUrl}/${BodyAdvisor}`;

                return this.http.get<AdvisorSingularData | null>(urlWithTimestamp, { headers }).pipe(
                    retry(2),
                    map((data) => data ?? { data: { Asesor: [] }, error: true }),
                    catchError((error) => {
                        console.error(`Failed request for getAdvisorInformation ${BodyAdvisor}:`, error);
                        return of({ data: { Asesor: [] }, error: true });
                    })
                );
            })
        );
    }

    public getAdvisorsList(_sessionId: string): Observable<AdvisorResponse> {
        return this.authService.getAuthHeaders().pipe(
            switchMap(headers => {
                const urlWithTimestamp = `${this.baseUrl}`;

                return this.http.get<AdvisorResponse | null>(urlWithTimestamp, { headers }).pipe(
                    retry(2),
                    map((data) => data ?? { data: { Asesores: [] }, error: true }),
                    catchError((error) => {
                        console.error(`Failed request for getAdvisorList: ${error}`);
                        return of({ data: { Asesores: [] }, error: true });
                    })
                );
            })
        );
    }
        

}
